import { Reducer } from 'umi';

export const FILTER_EXTEND_NAMESPACE = 'intelligence_store_rank_filter_extend';

interface TimeFilterType {
  type: string; // 'daily'|'weekly'|'monthly';
  filterType: string; // 'date'|'week'|'month';
  value: string[];
}
interface MarketFilterType {
  regions: string[];
  markets: string[];
  type: 'market' | 'region';
}
interface StateType {
  isOperate: boolean;
  isClickSensorTowTag: boolean;
  topchartFilterExtendCommon: any;
  timeFilterExtendCommon: TimeFilterType;
  timeFilterExtendOnlyDay: TimeFilterType;
  marketFilterExtendCommon: MarketFilterType;
  marketFilterExtendDropdown: MarketFilterType;
}
interface FilterExtendModelType {
  namespace: string;
  state: StateType;
  reducers: {
    saveAllSizerInitFunc: Reducer<StateType>;
    saveIsOperate: Reducer<StateType>;
    saveTimeFilterExtendCommon: Reducer<StateType>;
    saveTimeFilterExtendOnlyDay: Reducer<StateType>;
    saveMarketFilterExtendCommon: Reducer<StateType>;
    saveMarketFilterExtendDropdown: Reducer<StateType>;
  };
}
const sizerInit = {
  isOperate: false,
  topchartFilterExtendCommon: {},
  isOperateDetail: false,
  isOperateRegion: false,
  isClickSensorTowTag: false,
  detailFilterExtendCommon: {},
  /** 公共时间筛选器继承 */
  timeFilterExtendCommon: {
    type: '', // daily, weekly, monthly
    filterType: '', // date, week,month
    value: ['', ''], // [string, string]
  },
  /** 单日粒度筛选器 */
  timeFilterExtendOnlyDay: {
    type: '',
    filterType: '',
    value: ['', ''],
  },
  /** 公共国家筛选器继承 */
  marketFilterExtendCommon: {
    regions: [],
    markets: ['global'],
    type: 'market',
  },
  /** 下拉国家筛选器 */
  marketFilterExtendDropdown: {
    regions: [],
    markets: ['global'],
    type: 'market',
  },
};
const FilterExtendModel: FilterExtendModelType = {
  namespace: FILTER_EXTEND_NAMESPACE,
  state: sizerInit,

  reducers: {
    saveAllSizerInitFunc(state: StateType, action: any) {
      return {
        ...sizerInit,
      };
    },
    saveIsOperate(state: StateType, action: any) {
      return {
        ...state,
        isOperate: action.payload,
      };
    },
    saveTopchartFilterExtendCommon(state: StateType, action: any) {
      return {
        ...state,
        topchartFilterExtendCommon: !action.payload ? {} : action.payload,
      };
    },
    saveIsOperateDetail(state: StateType, action: any) {
      return {
        ...state,
        isOperateDetail: action.payload,
      };
    },
    saveIsOperateRegion(state: StateType, action: any) {
      return {
        ...state,
        isOperateRegion: action.payload,
      };
    },
    saveDetailFilterExtendCommon(state: StateType, action: any) {
      return {
        ...state,
        detailFilterExtendCommon: !action.payload ? {} : action.payload,
      };
    },
    saveTimeFilterExtendCommon(state: StateType, action: any) {
      return {
        ...state,
        timeFilterExtendCommon: action.payload,
      };
    },
    saveTimeFilterExtendOnlyDay(state: StateType, action: any) {
      return {
        ...state,
        timeFilterExtendOnlyDay: action.payload,
      };
    },
    saveMarketFilterExtendCommon(state: StateType, action: any) {
      return {
        ...state,
        marketFilterExtendCommon: action.payload,
      };
    },
    saveMarketFilterExtendDropdown(state: StateType, action: any) {
      return {
        ...state,
        marketFilterExtendDropdown: action.payload,
      };
    },
    saveIsClickSensorTowTag(state: StateType, action: any) {
      return {
        ...state,
        isClickSensorTowTag: action.payload,
      };
    },
  },
};

export default FilterExtendModel;
